import { render, staticRenderFns } from "./BillingNetworkTag.vue?vue&type=template&id=c4bf14f8&scoped=true&"
import script from "./BillingNetworkTag.vue?vue&type=script&lang=ts&"
export * from "./BillingNetworkTag.vue?vue&type=script&lang=ts&"
import style0 from "./BillingNetworkTag.vue?vue&type=style&index=0&id=c4bf14f8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bf14f8",
  null
  
)

export default component.exports